export default "__VITE_ASSET__xF6AQwx0__"